import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import {
  TenantAddRequest,
  TenantUpdateRequest,
  TenantResponse,
} from '@entities/tenant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  constructor(private api: ApiService) {}

  /**
   * テナント一覧を取得する
   * @returns テナント一覧
   */
  findAll(): Observable<TenantResponse[]> {
    const url = '/tenants';
    return this.api.get<TenantResponse[]>(url);
  }

  /**
   * テナント詳細情報を取得する
   * @param tenantId テナントID
   * @returns テナント詳細情報
   */
  find(tenantId: string): Observable<TenantResponse> {
    const url = `/tenants/${tenantId}`;
    return this.api.get<TenantResponse>(url);
  }

  /**
   * テナントを追加する
   * @param request 追加内容
   */
  add(request: TenantAddRequest): Observable<TenantAddRequest> {
    const url = '/tenants';
    return this.api.post<TenantAddRequest>(url, request);
  }

  /**
   * テナントを更新する
   * @param request 更新内容
   */
  update(request: TenantUpdateRequest): Observable<TenantResponse> {
    const url = `/tenants/${request.tenantId}`;
    return this.api.put<TenantResponse>(url, request);
  }

  /**
   * テナントを削除する
   * @param tenantId テナントID
   */
  delete(tenantId: string): Observable<void> {
    const url = `/tenants/${tenantId}`;
    return this.api.delete<void>(url);
  }
}
